import { tsrContractsClient } from '../tsrContractsClient';

export const patientDetailsClient = () => tsrContractsClient.patientDetailsContract;
